import { X_PAGE_ID } from 'reactApp/appHelpers/configHelpers';
import {
    enableStarsAiOrganizeIconInDatalist,
    isAiOrganizeSearchButton,
    isAiOrganizeSortButton,
    PROMO_STARS_TIP_ID,
    showTipInterval,
    showTipLimit,
    storageKeyForPopup,
} from 'reactApp/appHelpers/featuresHelpers/features/fakedoorNeuroOrganizePromo';
import { type StorageData, getBannerDataFromStorage, safetyPersonalLocalStorage } from 'reactApp/storage';

// Пройден ли фекдор любым из способов?
export const isFakedoorCompleted = () => {
    return getBannerDataFromStorage(storageKeyForPopup).state;
};

type AiOrganizePromoVariant = 'datalist' | 'search' | 'sort';
type ExpVariants = 0 | 1 | 2;

let isCompleted: undefined | boolean;
let startDate: undefined | number;

const variants: Record<ExpVariants, AiOrganizePromoVariant> = { 0: 'datalist', 1: 'search', 2: 'sort' };
const oneDayInSeconds = 60 * 60 * 24;

export const markFakedoorIsCompleteByModalClick = () => {
    isCompleted = true;

    safetyPersonalLocalStorage.setItem(
        storageKeyForPopup,
        JSON.stringify({
            ...getBannerDataFromStorage(storageKeyForPopup),
            state: true,
        })
    );
};

export const checkTooltipCanBeShown = (tipId: string) => {
    // Получаем данные о прошлых показах
    const storageData = getBannerDataFromStorage(tipId);

    // Текущее количество показов
    const countShow = storageData?.shows?.length || 0;
    // Завершили ли фейкдор через иконку с тултипом?
    const isComplete = storageData?.isComplete;
    // Время последнего показа
    const lastShowTime = storageData?.time || 0;

    const currentTime = Math.floor(new Date().getTime() / 1000);

    // Прошло ли достаточное количество времени для показа?
    const isCanShowByTime = currentTime - showTipInterval > lastShowTime;
    // Показывали ли тултипы в рамках текущей сессии?
    const isShowInCurrentSession = storageData?.shows?.includes(X_PAGE_ID);

    // Можем ли показать тултип?
    const isCanShowAiTooltip =
        !isFakedoorCompleted() &&
        (getBannerDataFromStorage(storageKeyForPopup)?.counts?.show || 0) > 0 &&
        // Прошло достаточное количество времени с прошлого показа
        isCanShowByTime &&
        // Не достигли лимита по показам
        countShow < showTipLimit;

    // Save show
    const newData: StorageData = { shows: storageData?.shows || [], isComplete, time: lastShowTime };
    // Если можем показать фейкдор и ещё не записывали показ из этой сессии - сохраняем показ
    if (!isShowInCurrentSession && isCanShowAiTooltip) {
        newData.shows?.push?.(X_PAGE_ID);
        newData.time = currentTime;
    }
    safetyPersonalLocalStorage.setItem(tipId, JSON.stringify(newData));

    return isCanShowAiTooltip;
};

const getAiOrganizePromoVariant = (): false | AiOrganizePromoVariant => {
    const isAny = enableStarsAiOrganizeIconInDatalist || isAiOrganizeSearchButton || isAiOrganizeSortButton;
    if (!isAny) {
        return false;
    }

    if (isCompleted === undefined) {
        isCompleted = isFakedoorCompleted();
    }

    if (isCompleted) {
        return false;
    }

    if (!startDate) {
        startDate = getBannerDataFromStorage(PROMO_STARS_TIP_ID)?.time || new Date().getTime() / 1000;
    }

    const variant: ExpVariants = (Math.trunc((Date.now().valueOf() / 1000 - startDate) / oneDayInSeconds) % 3) as ExpVariants;

    return variants[variant];
};

export const isAiOrganizeIconInDatalist = () =>
    enableStarsAiOrganizeIconInDatalist && !isCompleted && getAiOrganizePromoVariant() === 'datalist';
export const isAiOrganizeSearchBttnInToolbar = () => isAiOrganizeSearchButton && !isCompleted && getAiOrganizePromoVariant() === 'search';
export const isAiOrganizeSortBttnInToolbar = () => isAiOrganizeSortButton && !isCompleted && getAiOrganizePromoVariant() === 'sort';
